import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';
import Paper from 'material-ui/Paper';
import { List, ListItem } from 'material-ui/List';

import Loading from '../../Common/Loading';
import LoadingOverlay from '../../Common/LoadingOverlay';
import { fetchTenantsRoutine, selectTenantRoutine } from '../../../routines';
import AddTenantDialog from '../AddTenantDialog';
import {showDialog, isDialogOpen} from '../../../actions/dialogs';
import AlertDialog from '../../Common/AlertDialog';

import styles from './styles';

class SelectTenant extends Component {
  static propTypes = {
    fetchTenants: PropTypes.func.isRequired,
    onSelectTenant: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  };

  state = {};

  constructor(props) {
    super(props);
    this.state = {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
    };
  }

  componentWillMount() {
    if (this.props.user) {
      this.props.fetchTenants();
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.user && !this.props.user) {
      this.props.fetchTenants();
    }
  }

  renderTenant = (tenant) => {
    return (<ListItem
      key={tenant.id}
      leftIcon={tenant && tenant.logo ? <img alt="Logo" src={tenant.logo} style={styles.businessLogo}/> :
        <FontIcon className="material-icons" style={styles.businessIcon}>business</FontIcon>}
      rightIcon={<FontIcon className="material-icons" style={styles.selectIcon}>chevron_right</FontIcon>}
      primaryText={tenant.name}
      style={styles.tenantItem}
      onClick={() => {
        this.props.onSelectTenant(tenant);
        this.props.push('/');
      }}
    />);
  };

  renderTenants() {
    const { tenants, loading } = this.props;

    if (!loading && !tenants.length) {
      return <div style={styles.noTenants}>
        <FontIcon className="material-icons" style={styles.warningIcon} color="white">warning</FontIcon>
        You are not associated with any accounts. Please speak with an account administrator or create a new account
      </div>;
    }

    return (<List
      style={styles.list}
    >
      {tenants.map((tenant) => this.renderTenant(tenant))}
    </List>);
  }

  render() {
    const { tenants, showDialog, loading, dialogs } = this.props;

    return (
      <div style={styles.container}>
        <LoadingOverlay visible={loading}/>
        <img alt="Logo" src="/images/logo.png"/>
        <Paper style={styles.paper} zDepth={5}>

          {this.renderTenants(tenants)}

          <RaisedButton
            type="button"
            label="Logout"
            secondary
            style={styles.logout}
            onClick={() => this.props.push('/logout')}/>

          <RaisedButton
            type="button"
            primary
            label="Create New Account"
            style={styles.register}
            onClick={() => showDialog('addTenant')}/>
        </Paper>

        <AddTenantDialog />

        { isDialogOpen(dialogs, 'alert') ? <AlertDialog /> : null }
      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.getIn(['tenants','loading']),
    tenants: state.getIn(['tenants','tenants']).toJS(),
    error: state.get('authentication').get('error') ? state.get('authentication').get('error').toJS() : null,
    user: state.get('authentication').get('user'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    fetchTenants: fetchTenantsRoutine.trigger,
    onSelectTenant: selectTenantRoutine.success,
    push,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectTenant);



// WEBPACK FOOTER //
// ./src/components/Authentication/SelectTenant/index.js